<script setup lang="ts">
import { computed } from "vue";
import { useResumeStore } from "~/stores/useResumeStore";
import { useUiStore } from "~/stores/useUiStore";
import { useI18n } from "~/composables/useI18n";
import SectionNavTabs from "../SectionNavTabs/SectionNavTabs.vue";
import SkillsGrid from "../SkillsGrid/SkillsGrid.vue";
import LearningSection from "../LearningSection/LearningSection.vue";
import Footer from "~/components/ui/Footer/Footer.vue";
import { UiPageWrapper } from "#components";

const t = useI18n();

const store = useResumeStore();
const uiStore = useUiStore();

await Promise.all([store.loadResumeData(), store.loadBackground()]);

// Get data for footer
const personalInformation = computed(() => store.personalInformation);
const version = computed(() => uiStore.packageVersion);
</script>

<template>
  <!-- Sticky section tab nav -->
  <SectionNavTabs />

  <UiPageWrapper>
    <!-- Page header -->
    <div class="py-10">
      <UiTitle
        level="1"
        class="text-5xl md:text-7xl leading-16 md:leading-24 font-urbanist font-bold"
      >
        {{ t("skillsPage.pageTitle") }}
      </UiTitle>
      <UiParagraph
        class="text-lg md:text-2xl font-medium text-vshadow-sm shadow-secondary-900 leading-relaxed"
      >
        {{ t("skillsPage.pageDescription") }}
      </UiParagraph>
    </div>

    <!-- Skills section -->
    <div id="tools" class="pb-16 scroll-mt-[calc(var(--main-nav-height)+3rem)]">
      <UiTitle level="2" class="text-2xl font-semibold text-left mb-4">
        {{ t("skillsPage.skillsSectionHeading") }}
      </UiTitle>
      <UiParagraph class="mb-8">
        {{ t("skillsPage.skillsSectionSubheading") }}
      </UiParagraph>
      <SkillsGrid />
    </div>

    <!-- Learning section -->
    <div class="pb-16 scroll-mt-24">
      <LearningSection />
    </div>
  </UiPageWrapper>

  <Footer
    v-if="personalInformation?.location"
    :location="personalInformation.location"
    :email="personalInformation.email"
    :version="version"
  />
</template>
